import { URLS } from '../../constants';
import apiClient from '../client';

const loggingApis = {
  saveLog: ({
    type,
    message,
    config,
    trace,
  }: {
    type: string;
    message: string;
    config: string;
    trace: string;
  }) => {
    return apiClient.post(URLS.saveLog, {
      data: {
        type,
        message,
        config,
        trace,
      },
    });
  },
};

export default loggingApis;
